// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yQcVTeCi{display:flex;flex-direction:column;gap:max(1.13rem,min(1.25vw,1.5rem))}.vdIFCWyV{font-size:max(1.13rem,min(1.25vw,1.5rem));font-weight:600;font-weight:500}.wx3RQuxB{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "yQcVTeCi",
	"title": "vdIFCWyV",
	"btn": "wx3RQuxB"
};
module.exports = ___CSS_LOADER_EXPORT___;
